import React from 'react'

import {
	HoverCard,
	HoverCardContent,
	HoverCardTrigger,
} from '@/shared/components/ui/hover-card'

export function BasicImageField({
	value,
}: {
	value: string | null | undefined
}) {
	if (!value) {
		return (
			<div className='flex cursor-not-allowed items-center'>
				<div className='relative flex h-8 w-14 items-center justify-center overflow-hidden rounded-md border border-solid border-border bg-secondary'>
					<img src='/no-image-small.svg' />
				</div>
			</div>
		)
	}
	const onLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
		e.currentTarget.classList.add('cursor-pointer')
	}
	const onError = (e: React.SyntheticEvent<HTMLImageElement>) => {
		e.currentTarget.classList.add('pointer-events-none')
	}

	return (
		<div className='flex items-center'>
			<HoverCard>
				<HoverCardTrigger>
					<div className='relative flex h-8 w-14 items-center justify-center overflow-hidden rounded-lg border hover:border-primary'>
						<img
							loading='lazy'
							className='image-type'
							src={value}
							onLoad={onLoad}
							onError={onError}
						/>
					</div>
				</HoverCardTrigger>
				<HoverCardContent
					align='center'
					side='right'
					className='overflow-hidden p-0'
				>
					<img
						className='image-type'
						src={value}
						onLoad={onLoad}
						onError={onError}
					/>
				</HoverCardContent>
			</HoverCard>
		</div>
	)
}
